// Framework and third-party non-ui
import React, { useContext, useEffect, useState } from "react";
import { loadModules } from "esri-loader";

// App components
import TrailCard from "components/TrailCard";
import { MapContext } from "contexts/MapContext";
import { UserContext } from "contexts/UserContext";
import { CircularProgress } from "@material-ui/core";

// Third-party components (buttons, icons, etc.)
import { Virtuoso } from "react-virtuoso";
import AutoSizer from "react-virtualized-auto-sizer";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  numberTrails: {
    fontFamily: "Open Sans",
    fontSize: "14px",
    lineHeight: "20px",
    letterSpacing: "0.25px",
    color: "#222222",
    position: "relative",
    top: "70px",
    left: "25px",
  },
}));
const TrailsList = () => {
  const { filteredFeatureList } = useContext(MapContext);
  const { userInfo } = useContext(UserContext);
  const [loading, setLoading] = useState(true);
  const [favoritedTrails, setFavoritedTrails] = useState([]);
  const classes = useStyles();

  useEffect(() => {
    if (!filteredFeatureList.length) {
      setLoading(false);
    }
    if (userInfo) {
      (async () => {
        const [esriRequest] = await loadModules(["esri/request"]);

        let res = await esriRequest(userInfo.favoritesUrl + "/query", {
          method: "post",
          query: {
            where: "IsFeaturedTrail = 0",
            f: "json", // format
          },
        });
        setFavoritedTrails(
          res.data.features.map((feature) => feature.attributes.TrailID)
        );
      })();
    }
  }, []);

  useEffect(() => {
    if (userInfo) {
      (async () => {
        const [esriRequest] = await loadModules(["esri/request"]);

        let res = await esriRequest(userInfo.favoritesUrl + "/query", {
          method: "post",
          query: {
            where: "IsFeaturedTrail = 0",
            f: "json", // format
          },
        });
        setFavoritedTrails(
          res.data.features.map((feature) => feature.attributes.TrailID)
        );
      })();
    }
  }, [userInfo]);

  useEffect(() => {
    if (filteredFeatureList.length) setLoading(false);
  }, [filteredFeatureList]);

  const getTrailDifficulty = (difficulty) => {
    if (difficulty === "Easy") {
      return "Easy";
    }
    if (difficulty === "Easiest") {
      return "Easiest";
    }
    if (difficulty === "MoreDiff") {
      return "Moderate";
    }
    if (difficulty === "VeryDiff") {
      return "Difficult";
    }
    if (difficulty === "ExtmDiff") {
      return "Extreme";
    }
    if (difficulty === "NA") {
      return "Not Assessed";
    }
    return "Not Assessed";
  };

  const getIcons = (attributes) => {
    const attrs = [
      "WHEELCHAIR_FRIENDLY",
      "DOGS",
      "SNOWMOBILES",
      "BIKES",
      "HORSES",
      "OFF_ROAD_4X4",
      "XC_SKIING",
      "STATUS",
    ];
    const icons = {};
    attrs.forEach((attr) => {
      if (
        ["Yes", "Var", "Recmnd", "Allow", "Open"].includes(attributes[attr])
      ) {
        icons[attr] = true;
      } else {
        icons[attr] = false;
      }
    });
    return icons;
  };

  const Row = (index) => {
    const attributes = filteredFeatureList[index].attributes;
    const geometry = filteredFeatureList[index].geometry;
    const difficulty = getTrailDifficulty(attributes.DIFFICULTY);
    const icons = getIcons(attributes);
    const favorited = favoritedTrails.includes(attributes.PRIMARY_TRAIL_ID)
      ? true
      : null;
    return (
      <TrailCard
        key={attributes.PRIMARY_TRAIL_ID}
        difficulty={difficulty}
        length={attributes.Length_SPC}
        attributes={attributes}
        geometry={geometry}
        icons={icons}
        fee={attributes.PRIMARY_NAME.length}
        setFavoritedTrails={setFavoritedTrails}
        favoritedTrails={favoritedTrails}
        favorited={favorited}
        loggedIn={userInfo ? true : false}
      />
    );
  };

  return (
    <>
      {loading ? (
        <CircularProgress
          color="inherit"
          style={{ position: "relative", top: "90px" }}
        />
      ) : (
        <>
          <div className={classes.numberTrails}>
            {`${filteredFeatureList.length}`} Trails
          </div>
          <AutoSizer style={{ position: "relative", top: "70px" }}>
            {({ width, height }) => (
              <Virtuoso
                style={{ width, height }}
                totalCount={filteredFeatureList.length}
                item={Row}
                overscan={500}
              ></Virtuoso>
            )}
          </AutoSizer>
        </>
      )}
    </>
  );
};

export default TrailsList;
